import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpandablePanelbarComponent } from './expandable-panelbar.component';
import { PanelBarModule, TabStripModule } from '@progress/kendo-angular-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { MatListModule,  } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { FormDialogModule } from '../form-dialog/form-dialog.module';
import { PanelbarService } from './expandable-panelbar.service';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DataGridModule } from '../data-grid/data-grid.module';


@NgModule({
  imports: [
    CommonModule,
    PanelBarModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    TabStripModule,
    MatButtonModule,
    ButtonModule,
    UploadModule,
    FormDialogModule,
    DataGridModule,
    MatTooltipModule,
  ],
  declarations: [
    ExpandablePanelbarComponent
  ],
  exports: [
    ExpandablePanelbarComponent,
  ],
  providers: [
    PanelbarService
  ]

})
export class ExpandablePanelbarModule { }
